import { put } from 'redux-saga/effects';
import { getZppCourseInfosSuccess, getZppCourseInfosFailure } from 'redux/actions';
import { getZppCourseInfosApiRequest } from 'api/balloon';
import { ZppCourseInfo } from 'domain/enitity';

export function* getZppCourseInfoSaga() {
  try {
    const { data: response } = yield getZppCourseInfosApiRequest();

    if (response.errors) {
      yield put(getZppCourseInfosFailure(response.errors));
      return;
    }

    const courseInfos = (response.data.zppCourseInfos || []).map(ZppCourseInfo);

    yield put(getZppCourseInfosSuccess({ courseInfos }));
  } catch (error) {
    yield put(getZppCourseInfosFailure(error));
  }
}
